import React, { Component } from 'react';
import './App/Stylesheets/main.css';

import Home from './App/Components/Home';


class App extends Component {
  render() {
    return (
      <Home />
    );
  }
}

export default App;
